import { RowItemData } from "../../components/datatable/interfaces";
import {
  VIDEOPOSITION_FIELD,
  STATION_FIELD,
  MAINCODE_FIELD,
  C1CODE_FIELD,
  C2CODE_FIELD,
} from "../../api-models/response/BluemetricFields";

export class VideoPlayerDamage {
  id: number;
  videoPosition: number;
  description: string;
  mainCode: string;
  c1Code: string;
  c2Code: string;

  constructor(data: RowItemData) {
    this.id = data.id;
    this.videoPosition = parseInt(data.displayValues[VIDEOPOSITION_FIELD].value);
    this.description = `${data.displayValues[STATION_FIELD].value ?? '-'} / ${data.displayValues[MAINCODE_FIELD].value}`;
    this.mainCode = data.displayValues[MAINCODE_FIELD].value;
    this.c1Code = data.displayValues[C1CODE_FIELD].value;
    this.c2Code = data.displayValues[C2CODE_FIELD].value;
  }
}
